import GlobalErrors from './GlobalErrors';

export default GlobalErrors;
